import React from "react"

const SpreadChangeStyle = ({adj, measureType, rem}) => {

    var parsedDif = parseFloat(adj).toFixed(2)

    // default styles //
    var displayStyle = {
        width: '80%',
        height: '65%',
        margin: '0 auto',
        borderRadius: '15px',
        background: 'white',
        color: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: rem,
        fontWeight: 400,
    }

    // set color styles //
    if ((adj >= 0.4 && measureType === 'week') || (adj >= 3.0 && measureType === 'season')) {
        
        // positive color //
        displayStyle['background'] = '#e8fcf6'
        displayStyle['color'] = '#259c72'
 
    } else if ((adj <= -0.4 && measureType === 'week') || (adj <= -3.0 && measureType === 'season')) {
       
       // negative color //
       displayStyle['background'] = '#fae3eb'
       displayStyle['color'] = '#bf2a5e'

    }

    return (
        <div
            style={displayStyle}
        >
            {parsedDif}
        </div>
    )

}

export default SpreadChangeStyle